import { ProductsActions } from "../../reducers/products/ActionsNames";
import { IPurchaseFormValues } from "../../containers/Purchase/PurchaseForm";

export default function (values: IPurchaseFormValues) {
  return {
    type: ProductsActions.SubmitForm,
    values,
  };
}
